module.exports = __webpack_public_path__ + "static/media/zdislava-bell.c85b4f24.jpg";